<template>
  <div class="xy-container pageModule">
    <Title />
    <div ref="allList" class="list_content xy-scroll-col">
      <header v-show="!testunion">
        <div class="composite-box">
          <a-row type="flex">
            <a-col>
              <div class="composite-list">
                <ul>
                  <li
                    v-for="item in taskTitList"
                    :key="item.id"
                    :class="{ active: isActive === item.id }"
                    @click="tabClick(item.id)"
                  >
                    <span>
                      {{ item.name }}
                    </span>
                  </li>
                </ul>
              </div>
            </a-col>
          </a-row>
        </div>
      </header>
      <div v-if="listShow" class="content_div">
        <div v-if="isActive == 1" class="search_div">
          <span class="span">学年学期：</span>
          <a-select
            v-model="form.schoolYear"
            class="select"
            placeholder="请选择学期学年"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in schoolyearList"
              :key="i"
              :value="val.Id"
            >
              {{ val.Name }}
            </a-select-option>
          </a-select>
          <span class="span">年级：</span>
          <a-select
            v-model="form.gradeId"
            style="width: 120px"
            class="select"
            placeholder="请选择年级"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in gradeList"
              :key="i"
              :value="val.gradeId"
            >
              {{ val.gradeName }}
            </a-select-option>
          </a-select>
          <span class="span">考试类型：</span>
          <a-select
            v-model="form.meExamType"
            style="width: 120px"
            class="select"
            placeholder="考试类型"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in examTypeList"
              :key="i"
              :value="val.value"
            >
              {{ val.label }}
            </a-select-option>
          </a-select>
          <span class="span">考试名称：</span>
          <a-select
            v-model="form.examId"
            class="select"
            placeholder="考试名称"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm()"
          >
            <a-select-option
              v-for="(val, i) in examList"
              :key="i"
              :value="val.value"
              :title="val.label"
            >
              <span :title="val.lable">{{ val.lable }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div v-else class="search_div">
          <span class="span">考试名称：</span>
          <a-select
            v-model="form.examId"
            class="select"
            placeholder="考试名称"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm()"
          >
            <a-select-option
              v-for="(val, i) in examList"
              :key="i"
              :value="val.value"
              :title="val.label"
            >
              <span :title="val.lable">{{ val.lable }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div
          v-if="examInfoList && !examInfoList.length"
          class="not_div"
          style="height: 100%"
        >
          <NotData>
            <template #msg>
              {{ notDataMsg || '当前筛选条件下没有数据' }}
            </template>
          </NotData>
        </div>
        <div class="content-card xy-container-lg">
          <div
            v-for="(item, index) in examInfoList"
            :key="index"
            class="exam-list"
          >
            <div class="exam-list-top">
              <div class="exam-list-icon">
                <img
                  :src="require(`./img/icon-${item.meExamType}.png`)"
                  class="exam-list-icon-img"
                />
              </div>
              <div class="exam-list-content">
                <div class="exam-list-content-item">
                  <div class="tag">
                    <a-tag color="blue">
                      {{ item.gradeName }}
                    </a-tag>
                  </div>
                  <div class="exam-list-title">
                    【{{
                      (examTypeData[item.meExamType] &&
                        examTypeData[item.meExamType].name) ||
                      '--'
                    }}】{{ item.name }}
                  </div>
                  <a-divider type="vertical" />
                  <div class="exam-list-extend" @click="extendsFc(item)">
                    {{ item.show ? '收起' : '展开' }}
                    <a-icon
                      :class="[
                        item.show
                          ? 'icon-annimation-active1'
                          : 'icon-annimation-active2'
                      ]"
                      type="up"
                    />
                  </div>
                </div>
                <div class="exam-list-content-item exam-list-time">
                  考试时间：{{ FormatDate(item.meExamTime) }}
                </div>
              </div>
            </div>
            <div
              :class="[
                'exam-list-extends',
                item.show ? 'exam-list-extends-open' : ''
              ]"
            >
              <div class="exam-list-extends-box">
                <div v-if="item.fullScore" class="exam-list-extends-item">
                  <div
                    class="download-card"
                    @click="downLoadReport('total', item)"
                  >
                    <div class="download-card-item">
                      <img
                        src="./img/file-icon.png"
                        class="download-card-item-icon"
                      />
                      <div>总分报表下载</div>
                    </div>
                  </div>
                </div>
                <div class="exam-list-subject-title">单科下载</div>
                <div class="exam-list-extends-item">
                  <div
                    v-for="(items, indexc) in item.lists"
                    :key="indexc"
                    class="download-card"
                    @click="downLoadReport('single', { ...item, ...items })"
                  >
                    <div class="download-card-item">
                      <img
                        src="./img/file-icon.png"
                        class="download-card-item-icon"
                      />
                      <div>{{ items.courseName }}报表下载</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backtop :data-ele="dataEle" />
    </div>
  </div>
</template>
<script>
  import axios, { setStore, getUser, getStore, DateFormat } from '@/utils'

  import { downFilter } from '@xy/utils'

  export default {
    name: '',
    data() {
      return {
        testunion: true,
        isActive: this.$store.state.examIsActive, // 当前选中的tab
        taskTitList: [
          {
            id: 1,
            name: '校考考试'
          }
        ],
        schoolyearList: [],
        form: {
          schoolYear: '', //学年学期
          gradeId: -1, //年级
          examId: 0, //考试名称
          meExamType: -1 //考试类型
        },
        examTypeData: {},
        examTypeList: [
          {
            label: '全部',
            value: -1
          },
          { label: '练习', value: '0' },
          { label: '周考', value: '1' },
          { label: '月考', value: '2' },
          { label: '期中考试', value: '3' },
          { label: '期末考试', value: '4' },
          { label: '模拟考试', value: '5' }
        ],
        gradeList: [
          {
            gradeId: -1,
            gradeName: '全部'
          }
        ],
        examList: [{ label: '所有考试', value: 0 }],
        examInfoList: undefined,
        totalStatus: false,
        stageType: '',
        listShow: false,
        bureauId: null,
        isTOurl: false,
        notDataMsg: '',
        dataEle: null
        // recalculate: false //重新计算
      }
    },
    computed: {
      isAdmin() {
        const userInfo = getStore('userInfo') || {}
        let Role = userInfo.roleStr
        return Role && Role.includes('A')
      }
    },
    created() {
      //数组转对象
      this.examTypeList.forEach(item => {
        this.examTypeData[item.value] = {
          name: item.label
        }
      })
    },
    mounted() {
      this.dataEle = this.$refs.allList
      let { role, bureauId } = JSON.parse(localStorage.getItem('userInfo'))
      this.testunion = role === 6 ? true : false
      this.bureauId = bureauId

      this.tabClick()

      if (process.env.NODE_ENV == 'com' && getStore('userInfo').bureauId == 3) {
        this.isTOurl = true
      }
      if (
        process.env.NODE_ENV == 'development' &&
        getStore('userInfo').bureauId == 31
      ) {
        this.isTOurl = true
      }
      if (
        process.env.NODE_ENV == 'production' &&
        getStore('userInfo').bureauId == 31
      ) {
        this.isTOurl = true
      }
    },
    methods: {
      extendsFc(item) {
        item.show = !item.show
        console.log(item, '--i--', this.examInfoList)
      },
      tabClick(index = this.isActive) {
        this.isActive = index // 1 = 校考考试, 2 = 联考考试
        this.$store.state.examIsActive = this.isActive
        this.listShow = false
        this.form.examId = 0
        this.getUser(index)
      },
      changeForm(type) {
        if (type) {
          this.examList = [{ label: '所有考试', value: 0 }]
          this.examId = 0
          this.getExamlist()
          this.getListcontent()
        }
        if (!type) {
          this.getListcontent()
        }
      },
      // 获取用户信息
      getUser() {
        getUser().then(res => {
          if (res.status === true) {
            this.userInfo = res.data
            this.$store.commit('setuserInfo', res.data)
            setStore('userInfo', res.data)
            // 获取年级下拉框
            this.getGradeList()
            this.getSchoolyear()
            let icon = res.data.schoolIcon
            if (icon) {
              this.changeFavicon(icon)
            }
          }
        })
      },
      // 更换网页icon
      changeFavicon(link) {
        let favicon = document.querySelector('link[rel="icon"]')
        if (favicon !== null) {
          favicon.href = link
        } else {
          favicon = document.createElement('link')
          favicon.rel = 'icon'
          favicon.href = link
          document.head.appendChild(favicon)
        }
      },
      // 获取年级下拉框
      getGradeList() {
        this.gradeList = [
          {
            gradeId: -1,
            gradeName: '全部'
          }
        ]
        let params = {
          schoolId: this.userInfo.schoolId
        }
        axios({
          host: 'testApi',
          url: 'getevagrade',
          params,
          loading: true
        }).then(res => {
          if (res.status) {
            this.gradeList = this.gradeList.concat(res.data)
          }
        })
      },
      getSchoolyear() {
        axios({
          host: 'baseApi',
          url: 'getschoolyearandsemester',
          loading: true
        }).then(res => {
          let schoolyearList = res.data || []
          let querySchoolYear = this.$route.query.schoolYear
          // 跳转过来回显选中学年学期
          if (querySchoolYear) {
            let arr = schoolyearList.filter(item => item.Id == querySchoolYear)
            this.form.schoolYear = arr.length
              ? +querySchoolYear
              : schoolyearList[0].Id
          }
          if (!querySchoolYear) {
            schoolyearList.forEach(item => {
              item.isCurrent && (this.form.schoolYear = item.Id)
            })
            if (!this.form.schoolYear)
              this.form.schoolYear = schoolyearList[0].Id
          }
          this.schoolyearList = schoolyearList
          this.getExamlist()
          this.getListcontent()
        })
      },
      //查询考试
      getExamlist() {
        let params = {
          enterYear: 0,
          schoolYear: this.form.schoolYear,
          gradeId: this.form.gradeId,
          meExamType: this.form.meExamType
        }
        axios({
          url: 'examList',
          params,
          loading: true
        }).then(res => {
          if (res.status) {
            this.examList = res.data.list || []
            if (this.examList.length) {
              this.form.examId = this.examList[0].value
            }
            if (!this.examList.length) {
              this.form.examId = undefined
            }
          }
        })
      },
      getListcontent() {
        let params = {
          enterYear: 0,
          gradeId: this.form.gradeId,
          examId: this.form.examId || 0,
          meExamType: this.form.meExamType,
          schoolYear: this.form.schoolYear
        }
        axios({
          url: 'getdownloadexamlist',
          params,
          loading: true,
          noTip: true
        }).then(res => {
          this.notDataMsg = res.msg
          if (!this.form.examId) this.form.examId = 0
          if (res.status && res.data) {
            this.examInfoList =
              res.data.map(item => {
                item.show = false
                return item
              }) || []
          } else {
            this.examInfoList = []
          }
          this.listShow = true
        })
      },
      //时间格式转换
      FormatDate(date) {
        return DateFormat(date, 'yyyy.MM.dd')
      },
      //下载策略报表
      downLoadReport(tag, item) {
        const sendData = {
          url: 'exportmultireport',
          params: {
            meId: item.meId
          }
        }
        if (tag === 'single') {
          //单科
          sendData.url = 'exportsinglereport'
          sendData.params.seId = item.seId
        }
        axios({
          url: sendData.url,
          loading: true,
          params: sendData.params
        }).then(res => {
          if (res.status) {
            downFilter(
              process.env.VUE_APP_API_defaulteApi + res.data.reportUrl,
              res.data.reportName
            )
            // window.open(res.data.reportUrl, '_blank', '')
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.setgreadModal .ant-modal-body {
    max-height: 620px;
    overflow-y: auto;
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }
  .pageModule {
    width: 100%;
    height: 100%;
    background: #f9f9fa;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    padding-right: 0;
  }
  .right {
    float: right;
  }
  header {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-bottom: 1px solid #dcdee0;
    // box-shadow: 0px -1px 0px 0px #eeeeee inset;
    // margin-bottom: 12px;
    .composite-box {
      width: 100%;
      margin: 0 auto;
      height: auto;
      display: flex;
      justify-content: flex-start;
      .tab_right {
        flex: 1;
        height: 50px;
        display: flex;
        // background: red;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;
        border-bottom: 1px solid #dcdee0;
      }
      .composite-list {
        width: auto;
        height: 50px;
        // margin-left: 52px;
        ul {
          margin-bottom: 0;
          li {
            float: left;
            min-width: 120px;
            height: 50px;
            // padding: 14px 20px;
            border: 1px solid #dcdee0;
            border-right: none;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            color: #888888;
            line-height: 50px;
            padding: 0 29px;
            position: relative;
            &:last-child {
              border-right: 1px solid #dcdee0;
            }
          }
          .active {
            color: @primary-color;
            background: none;
            // border-bottom: 1px solid #fff;
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background: @primary-color;
            }
            span {
              font-weight: 550;
              // position: relative;
              // &:after {
              //   content: '';
              //   position: absolute;
              //   bottom: -17px;
              //   left: 0;
              //   height: 2px;
              //   width: 100%;
              //   background: #1677ff;
              // }
            }
          }
        }
      }
    }
  }
  .pageModulehead {
    height: 48px;
    line-height: 48px;
    background: white;
    border-bottom: 1px #e5e5e5 solid;
    .title {
      float: left;
      margin-left: 20px;
      font-size: 16px;
      font-weight: 550;
      color: #333333;
      border-bottom: 1px solid #f7f8fb;
    }
  }
  .list_content {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: auto;
    padding-right: 18px;
    scrollbar-gutter: stable;
    // 这个属性设置预留滚动条的宽度所以右padding就减6px

    .content_div {
      background: #fff;
      display: flex;
      flex-direction: column;
      flex: auto;
      .search_div {
        // min-height: 64px;
        line-height: 50px;
        padding: 8px 16px;
        background-color: #fff;
        position: relative;
        .in-bk {
          display: inline-block;
        }
        .span {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          margin-left: 16px;
        }
        .input {
          margin-left: 16px;
          width: 200px;
        }
        .select {
          width: 200px;
        }
        .btn {
          margin-top: 16px;
        }
      }
    }
  }
  .content-card {
    // padding: 0 32px 24px;
    padding-top: 0;
    .exam-list {
      display: flex;
      flex-direction: column;
      padding: 0 12px;
      border-bottom: 1px solid #e5e5e5;
      &:first-child {
        border-top: 1px solid #e5e5e5;
      }
      .exam-list-top {
        display: flex;
        padding: 16px 0;
      }
      .exam-list-icon {
        margin-right: 24px;
        .exam-list-icon-img {
          width: 48px;
          height: 48px;
        }
      }
      .exam-list-content {
        display: flex;
        flex-direction: column;
        .exam-list-content-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          .exam-list-title {
            max-width: 800px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            margin-right: 20px;
          }
          .exam-list-extend {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #4b5d6c;
            margin-left: 20px;
            cursor: pointer;
          }
          .exam-list-time {
            font-size: @font-size-base;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
      .exam-list-extends {
        display: flex;
        width: 100%;
        overflow: hidden;
        max-height: 0;
        transition: max-height 0.5s ease;
        .exam-list-extends-box {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding: 20px 0;
          border-top: 1px dashed #e5e5e5;
        }
        .exam-list-subject-title {
          margin-bottom: @padding-sm;
        }
        .exam-list-extends-item {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: @padding-md;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .download-card {
          box-shadow: 0px 2px 8px 0px rgba(60, 100, 239, 0.0882);
          border-radius: @border-radius-base;
          padding: 10px 16px;
          margin-right: 32px;
          cursor: pointer;
          .download-card-item {
            display: flex;
            align-items: center;
            .download-card-item-icon {
              width: 24px;
              height: 24px;
              margin-right: 15px;
            }
          }
        }
      }
      .exam-list-extends-open {
        max-height: 600px;
      }
      .icon-annimation-active1 {
        transform: rotate(0deg);
        transition: 0.5s;
      }
      .icon-annimation-active2 {
        transform: rotate(180deg);
        transition: 0.5s;
      }
    }
  }
</style>
